import { ChangeDetectionStrategy, Component, input } from '@angular/core';

/** Shared spinner overlay shown while a video/report dialog is being resolved and opened. */
@Component({
  selector: 'app-loading-overlay',
  template: `
    <div
      [class]="
        (fixed()
          ? 'fixed inset-0 z-[2000] bg-primary-darkest-gray/80'
          : 'absolute inset-0 z-20 bg-primary-darkest-gray/60') +
        ' flex flex-col items-center justify-center gap-3 backdrop-blur-sm cursor-wait'
      "
      role="status"
      aria-live="polite"
    >
      <span class="w-10 h-10 rounded-full border-2 border-white/30 border-t-accent animate-spin"></span>
      @if (label()) {
        <span class="font-header text-white text-[11px] tracking-[0.08em] uppercase opacity-80">{{ label() }}</span>
      }
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoadingOverlayComponent {
  readonly label = input<string>('');
  readonly fixed = input<boolean>(false);
}
